import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const UNLOCKED_CLIENTS_FORM_NAME = 'unlockedClients-filter';

const { client, contactType, note } = COMMON_FORM_FIELD_NAMES;

// FIELDS only as ids - no formDescriptorFn needed - textField outputs only
export const FIELDS = {
	client,
	contactType,
	worker: 'worker',
	creationDateFrom: 'creationDateFrom',
	creationDateTo: 'creationDateTo',
	creationTimeFrom: 'creationTimeFrom',
	creationTimeTo: 'creationTimeTo',
	distributionChannel: 'distributionChannel',
	note,
};
